import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <p>Coming Soon</p>
        </div>
    );
};

export default Dashboard;